import { Stack, Typography } from '@mui/material';
import { FormPaper, FormTitle } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { FirstSection } from './FirstSection';
import { useDictionary } from 'Hooks';
export const VerifyDetails = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.VERIFY_DETAILS);

  return (
    <Stack alignItems='center' component={'main'} role={'main'}>
      <FormTitle title={dictionary.title} />
      <Typography sx={{ mb: '32px' }}>
        {dictionary.firstSectionFirstParagraph}
      </Typography>
      <FormPaper>
        <FirstSection />
      </FormPaper>
    </Stack>
  );
};
